"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderComponent = void 0;
var React = require("react");
var __1 = require("../../../../");
var _Core_1 = require("../../../../_Core");
var Folder_styles_1 = require("./Folder.styles");
exports.FolderComponent = React.forwardRef(function (_a, ref) {
    var Item = _a.Item, OnFolderClick = _a.OnFolderClick, OnSelect = _a.OnSelect, Selected = _a.Selected;
    React.useImperativeHandle(ref, function () { return ({
        FireAddClick: function () {
            handleOnClick();
        },
    }); });
    var handleOnClick = function (e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        OnSelect(Item)
            .then(function () { return OnFolderClick
            ? OnFolderClick(Item)
            : undefined; });
    };
    return (React.createElement(Folder_styles_1.FolderContainerDiv, { onClick: handleOnClick },
        React.createElement(__1.HStack, { Gap: "xSmall", AutoColumns: "auto 1fr" },
            React.createElement(__1.Icon, { Icon: Item.IsExpanded ? _Core_1.Icons.FolderOpen : _Core_1.Icons.Folder, Height: "24px", Width: "24px" }),
            React.createElement("div", null, Item.Caption))));
});
